import { useDatasourceLoader, LoadOutcome } from "./useDatasourceLoader";
import { clearCostModelReportTable } from "../../excel/datasources/reportTables";
import { CostModel } from "../../interfaces/CostModel";
import { clearCostModelCaches } from "../../api/costModels";

export function useCostModelLoader() {
  const { loadDatasources } = useDatasourceLoader();

  const loadCostModel = (costModel: CostModel): Promise<LoadOutcome> =>
    loadDatasources([{ type: "cost-model", costModel }]);

  /**
   * Cost Model writes no data sheet, so its workbook footprint is the .metadata row and its caches.
   */
  const clearCostModel = async (): Promise<void> => {
    await clearCostModelReportTable();
    clearCostModelCaches();
  };

  return { loadCostModel, clearCostModel };
}
